
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Le 6 juin, les mesures du Covid 19 ont été encore assouplies en Suisse.
Seulement voilà, moins d'une personne sur dix dans le pays a été infectée par le
nouveau coronavirus. Toutes les autres ne disposent donc d'aucune immunité, et
de nouvelles flambées épidémiques sont pratiquement inévitables.`}</p>
    <p>{`Afin que les hôpitaux ne soient pas totalement submergés, les cas suspects
doivent être `}<strong parentName="p">{`testés`}</strong>{`, `}<strong parentName="p">{`isolés`}</strong>{` et leurs contacts doivent être placés en
`}<strong parentName="p">{`quarantaine`}</strong>{`,
`}<a parentName="p" {...{
        "href": "https://smw.ch/article/doi/smw.2020.20225"
      }}>{`disent de nombreux experts`}</a>{`. La
Confédération et les cantons poursuivent désormais également cette stratégie.
Pour y parvenir, l'identification des personnes de contact est essentielle - par
le biais de ce que l'on appelle la recherche des contacts, ou le
`}<em parentName="p">{`contagt-tracing`}</em>{`. L'installation de l'application "SwissCovid" de la
confédération doit faciliter ce travail. Elle est disponible depuis le 25 juin
sur l'Apple Store et le Google Play Store. L'Allemagne, l'Autriche et l'Italie
ont déjà lancé des applications similaires de traçage de proximité.`}</p>
    <p>{`Voici pourquoi, d'un point de vue épidémiologique, il est utile d'installer une
telle application.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;